import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  toolbar: {
    justifyContent: 'space-between',
    minWidth: 0,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
});
